var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMainGridOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_main_grid_on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.431373 0 0 0 0 0.129412 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.694118 0 0 0 0 0.694118 0 0 0 0 0.694118 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_main_grid_on",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Group-Copy-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-2)",
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,9 L3,9 C3.55,9 4,8.55 4,8 L4,6 C4,5.45 3.55,5 3,5 L1,5 C0.45,5 0,5.45 0,6 L0,8 C0,8.55 0.45,9 1,9 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,14 L3,14 C3.55,14 4,13.55 4,13 L4,11 C4,10.45 3.55,10 3,10 L1,10 C0.45,10 0,10.45 0,11 L0,13 C0,13.55 0.45,14 1,14 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,4 L3,4 C3.55,4 4,3.55 4,3 L4,1 C4,0.45 3.55,0 3,0 L1,0 C0.45,0 0,0.45 0,1 L0,3 C0,3.55 0.45,4 1,4 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,9 L8,9 C8.55,9 9,8.55 9,8 L9,6 C9,5.45 8.55,5 8,5 L6,5 C5.45,5 5,5.45 5,6 L5,8 C5,8.55 5.45,9 6,9 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,14 L8,14 C8.55,14 9,13.55 9,13 L9,11 C9,10.45 8.55,10 8,10 L6,10 C5.45,10 5,10.45 5,11 L5,13 C5,13.55 5.45,14 6,14 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,4 L8,4 C8.55,4 9,3.55 9,3 L9,1 C9,0.45 8.55,0 8,0 L6,0 C5.45,0 5,0.45 5,1 L5,3 C5,3.55 5.45,4 6,4 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(10.000000, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,9 L3,9 C3.55,9 4,8.55 4,8 L4,6 C4,5.45 3.55,5 3,5 L1,5 C0.45,5 0,5.45 0,6 L0,8 C0,8.55 0.45,9 1,9 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,14 L3,14 C3.55,14 4,13.55 4,13 L4,11 C4,10.45 3.55,10 3,10 L1,10 C0.45,10 0,10.45 0,11 L0,13 C0,13.55 0.45,14 1,14 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,4 L3,4 C3.55,4 4,3.55 4,3 L4,1 C4,0.45 3.55,0 3,0 L1,0 C0.45,0 0,0.45 0,1 L0,3 C0,3.55 0.45,4 1,4 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,9 L8,9 C8.55,9 9,8.55 9,8 L9,6 C9,5.45 8.55,5 8,5 L6,5 C5.45,5 5,5.45 5,6 L5,8 C5,8.55 5.45,9 6,9 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,14 L8,14 C8.55,14 9,13.55 9,13 L9,11 C9,10.45 8.55,10 8,10 L6,10 C5.45,10 5,10.45 5,11 L5,13 C5,13.55 5.45,14 6,14 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,4 L8,4 C8.55,4 9,3.55 9,3 L9,1 C9,0.45 8.55,0 8,0 L6,0 C5.45,0 5,0.45 5,1 L5,3 C5,3.55 5.45,4 6,4 Z",
    id: "Path"
  })))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMainGridOn);
export default __webpack_public_path__ + "static/media/icon_main_grid_on.936bf1d570b62e1ce75ce378654fb730.svg";
export { ForwardRef as ReactComponent };